import { baseColors, Icon } from '@groupby/ui-components';
import styled from 'styled-components';
import { Tab, Tabs } from '@mui/material';
export const StyledTabs = styled(Tabs) `
  /* Mobile-first */
  position: relative;
  
  .MuiTabs-scrollButtons {
    @media (max-width: 900px) {
      &.Mui-disabled {
        opacity: 0.3;
      }
    }
  }

  .MuiTabs-indicator {
    z-index: 1;
  }

  .MuiPaper-root {
    box-shadow: none;
  }

  .MuiTabs-indicator {
    background-color: ${baseColors.primaryBlueMed700};
    min-width: ${({ theme }) => theme.spacing(10)};
    
    /* Desktop and up */
    @media (min-width: 900px) {
      min-width: ${({ theme }) => theme.spacing(15)};
    }
  }

  &:after {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    border-bottom: 2px solid ${baseColors.primaryBlueMed200};
    height: ${({ theme }) => theme.spacing(0.25)};
    width: 100%;
  }
`;
export const StyledTab = styled(Tab) `
  /* Mobile-first */
  && {
    position: relative;
    min-width: ${({ theme }) => theme.spacing(10)};
    min-height: unset;
    padding: ${({ theme }) => theme.spacing(1, 1.5)};
    font-size: 0.75rem;

    &.Mui-disabled {
      color: ${baseColors.primaryBlueMed400};
    }
    
    /* Tablet and up */
    @media (min-width: 600px) {
      min-width: ${({ theme }) => theme.spacing(13)};
      padding: ${({ theme }) => theme.spacing(1.5, 2)};
      font-size: 0.8125rem;
    }
    
    /* Desktop and up */
    @media (min-width: 900px) {
      min-width: ${({ theme }) => theme.spacing(15)};
      padding: ${({ theme }) => theme.spacing(2, 2.5)};
      font-size: 0.875rem;
    }
  }


  &.MuiButtonBase-root {
    color: ${baseColors.primaryBlueMed600};

    svg {
      width: ${({ theme }) => theme.spacing(1.75)};
      height: ${({ theme }) => theme.spacing(1.75)};
      
      /* Desktop and up */
      @media (min-width: 900px) {
        width: ${({ theme }) => theme.spacing(2)};
        height: ${({ theme }) => theme.spacing(2)};
      }
    }
  }

  &.MuiTab-textColorPrimary {
    color: ${baseColors.primaryBlueMed600};

    &.Mui-selected {
      color: ${baseColors.primaryBlueDark500};
    }
  }

  &.tab--has-errors {
    color: ${baseColors.darkRed};

    &.Mui-selected {
      color: ${baseColors.darkRed};
    }

    .MuiTabs-indicator {
      background-color: ${baseColors.darkRed};
    }
  }
`;
export const StyledTabRight = styled.div `
  /* Mobile-first */
  padding: ${({ theme }) => theme.spacing(0.5, 0.5, 0.5, 0)};
  margin-left: auto;
  
  /* Desktop and up */
  @media (min-width: 900px) {
    padding: ${({ theme }) => theme.spacing(1, 1, 1, 0)};
  }
`;
export const StyledIcon = styled(Icon) `
  && {
    position: relative;
    top: ${({ theme }) => theme.spacing(0.25)};
    left: ${({ theme }) => theme.spacing(0.25)};
    transform: scale(0.7);

    path {
      fill: ${baseColors.primaryGreen500};
    }
  }`;
